module.exports = __webpack_public_path__ + "img/Verrière porte fermé.19f80acb.jpg";